import React from 'react';
import { connect } from 'react-redux';
import { cocktailActions } from '../_actions';

class RecipeButton extends React.Component {

  constructor(props) {
    super(props);

    // begin modal
    this.state = {
      image: false
    };
  }
  componentDidMount() {
    this.props.dispatch(cocktailActions.getRecipeImage(this.props.thisRecipe._id));
  }

  render() {
    const {favorites, openModal, thisRecipe, recipe_image} = this.props;

  if (!this.state.image && recipe_image.image && recipe_image.image[thisRecipe._id] != undefined) {


    let key = Object.keys(recipe_image.image);

      if (thisRecipe._id == key[0]) {
        this.state.image = `data:image/png;base64,${recipe_image.image[thisRecipe._id]}`;
      }
  }

    let buttonClassName = 'recipe-button-one';
    let listClassName = 'ingredient-list';
    if (thisRecipe.missing && thisRecipe.missing.length > 1) {
      buttonClassName = 'recipe-button-two-plus';
      listClassName += ' ingredient-list-two-plus';
    }

// background: `url(data:image/png;base64,${thisRecipe.img_url}) no-repeat center/cover`,
    return (
      <button style={{border: 0, padding: 0}} onClick={() => openModal(thisRecipe, this.state.image)}>
      <div style={{width: '10rem', background: this.state.image ? `url(${this.state.image}) no-repeat center/cover` : 'none',  display: 'inline-block', position: 'relative', height: `20rem`, cursor: 'pointer'}}>
        {favorites && favorites.includes(thisRecipe.machine_name) &&
        <div style={{padding: '5px', top: '0px', right: '0px', position: 'absolute', boxSizing: 'border-box'}}>
          <img src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_favorite.ico" style={{width: '50px'}}/>
        </div>
        }
        <div className={buttonClassName}><strong>{thisRecipe.name}</strong>
          {thisRecipe.missing && thisRecipe.missing.length != 0 &&
          <div>
            {thisRecipe.missing && thisRecipe.missing.length < 3 &&
            <em>Missing ingredients:</em>
            }
            <ul className={listClassName}>
              {thisRecipe.missing.map((thisIngredient, index) =>
                <li>{thisIngredient.replace(/_/g, ' ')}</li>
              )
              }
            </ul>
          </div>
          }
        </div>
      </div>
        </button>
    )
  }
}

function mapStateToProps(state) {
  const { recipe_image } = state;
  return {
    recipe_image
  };
}

const connectedRecipeButton = connect(mapStateToProps)(RecipeButton);
export { connectedRecipeButton as RecipeButton };


// WEBPACK FOOTER //
// ./src/RecipeButton/RecipeButton.jsx